document.addEventListener('change', function () {
  const wrapper = document.querySelector('[data-personalization-wrapper]');
  if (!wrapper) return;

  const variantInput = document.querySelector('input[name="id"]');
  if (!variantInput) return;

  const selectedVariantId = variantInput.value;

  const variantsData = window.productVariants || [];
  const variant = variantsData.find(v => String(v.id) === selectedVariantId);

  if (!variant) {
    wrapper.hidden = true;
    return;
  }

  const isPersonalized = variant.options.includes('Personalized');

  wrapper.hidden = !isPersonalized;
});
